import BaseService from './baseService';

export default {
  aprovarRejeitar(itemLista) {
    return BaseService.post("regularidade/aprovarRejeitar",itemLista)
  },

  // Novo método adicionado
  getDocumentosRegularidade(idFornecSolicitacao) {
  return BaseService.get(`regularidade/documentos?idFornecSolicitacao=${idFornecSolicitacao}`);
  }
};
